module.exports = __webpack_public_path__ + "az.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/az.svg
// module id = 688
// module chunks = 0